(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["asx-base"]) return;
  try {
    
(function(){
  if(window.__asx)return;window.__asx=true;
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(reduce||!('IntersectionObserver' in window))return;
  document.documentElement.classList.add('asx-js');
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},{rootMargin:'0px 0px -10% 0px'});
  var px=[],pr=[],raf=0;
  function tick(){raf=0;var vh=window.innerHeight;
    px.forEach(function(el){var r=el.getBoundingClientRect();if(r.bottom<-200||r.top>vh+200)return;var c=(r.top+r.height/2-vh/2)/vh;el.style.setProperty('--py',(c*parseFloat(el.dataset.asxParallax||'0.1')*-100).toFixed(1)+'px');});
    pr.forEach(function(el){var r=el.getBoundingClientRect();var p=(vh*0.7-r.top)/Math.max(1,r.height-vh*0.3);el.style.setProperty('--p',Math.min(1,Math.max(0,p)).toFixed(3));});}
  function ask(){if(!raf)raf=requestAnimationFrame(tick);}
  function init(){var vh=window.innerHeight;document.querySelectorAll('[data-asx]:not(.is-in)').forEach(function(el){if(el.getBoundingClientRect().top<vh*0.9){requestAnimationFrame(function(){el.classList.add('is-in');});}else{io.observe(el);}});px=[].slice.call(document.querySelectorAll('[data-asx-parallax]'));pr=[].slice.call(document.querySelectorAll('[data-asx-progress]'));ask();}
  window.addEventListener('scroll',ask,{passive:true});
  window.addEventListener('resize',ask,{passive:true});
  document.addEventListener('focusin',function(e){var el=e.target.closest&&e.target.closest('[data-asx]');if(el)el.classList.add('is-in');});
  document.addEventListener('shopify:section:load',init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["asx-product-stage"] && !Shopify.designMode) return;
  try {
    
(function(){
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches||!window.matchMedia('(hover: hover)').matches)return;
  var raf=0,ev=null;
  document.addEventListener('pointermove',function(e){ev=e;if(raf)return;raf=requestAnimationFrame(function(){raf=0;
    var s=ev.target.closest&&ev.target.closest('.asx-ps');if(!s)return;var r=s.getBoundingClientRect();
    s.style.setProperty('--mx',(((ev.clientX-r.left)/r.width)*2-1).toFixed(3));
    s.style.setProperty('--my',(((ev.clientY-r.top)/r.height)*2-1).toFixed(3));});},{passive:true});
})();

  } catch(e) { console.error(e); }
})();
})();
